module.exports = __webpack_public_path__ + "static/media/jackfruit.559cd4ef.png";